export const userDrawerTranslations = {
  en: {
    usernamePlaceholder: "Username",
    logoutButton: "Logout",
    usernameCopied: "Username copied",
    packages: "Packages",
    categories: "Categories",
    licenses: "Licenses",
    adminZoneButton: "Admin zone",
    userZoneButton: "User zone",
  },
  cz: {
    usernamePlaceholder: "Uživatelské jméno",
    logoutButton: "Odhlásit se",
    usernameCopied: "Uživatelské jméno zkopírováno",
    packages: "Balíčky",
    categories: "Kategorie",
    licenses: "Licence",
    adminZoneButton: "Admin zóna",
    userZoneButton: "Uživatelská zóna",
  },
  fr: {
    usernamePlaceholder: "Nom d'utilisateur",
    logoutButton: "Se déconnecter",
    usernameCopied: "Nom d'utilisateur copié",
    packages: "Paquets",
    categories: "Catégories",
    licenses: "Licences",
    adminZoneButton: "Zone admin",
    userZoneButton: "Zone utilisateur",
  },
  es: {
    usernamePlaceholder: "Nombre de usuario",
    logoutButton: "Cerrar sesión",
    usernameCopied: "Nombre de usuario copiado",
    packages: "Paquetes",
    categories: "Categorías",
    licenses: "Licencias",
    adminZoneButton: "Zona de administración",
    userZoneButton: "Zona de usuario",
  },
  nl: {
    usernamePlaceholder: "Gebruikersnaam",
    logoutButton: "Uitloggen",
    usernameCopied: "Gebruikersnaam gekopieerd",
    packages: "Pakketten",
    categories: "Categorieën",
    licenses: "Licenties",
    adminZoneButton: "Beheerderszone",
    userZoneButton: "Gebruikerszone",
  },
  sk: {
    usernamePlaceholder: "Používateľské meno",
    logoutButton: "Odhlásiť sa",
    usernameCopied: "Používateľské meno skopírované",
    packages: "Balíky",
    categories: "Kategórie",
    licenses: "Licencie",
    adminZoneButton: "Admin zóna",
    userZoneButton: "Používateľská zóna",
  },
  de: {
    usernamePlaceholder: "Benutzername",
    logoutButton: "Abmelden",
    usernameCopied: "Benutzername kopiert",
    packages: "Pakete",
    categories: "Kategorien",
    licenses: "Lizenzen",
    adminZoneButton: "Admin-Bereich",
    userZoneButton: "Benutzerbereich",
  },
  hu: {
    usernamePlaceholder: "Felhasználónév",
    logoutButton: "Kijelentkezés",
    usernameCopied: "Felhasználónév másolva",
    packages: "Csomagok",
    categories: "Kategóriák",
    licenses: "Licenc",
    adminZoneButton: "Admin zóna",
    userZoneButton: "Felhasználói zóna",
  },
  pl: {
    usernamePlaceholder: "Nazwa użytkownika",
    logoutButton: "Wyloguj się",
    usernameCopied: "Nazwa użytkownika skopiowana",
    packages: "Pakiety",
    categories: "Kategorie",
    licenses: "Licencje",
    adminZoneButton: "Strefa administratora",
    userZoneButton: "Strefa użytkownika",
  },
  sv: {
    usernamePlaceholder: "Användarnamn",
    logoutButton: "Logga ut",
    usernameCopied: "Användarnamn kopierat",
    packages: "Paketer",
    categories: "Kategorier",
    licenses: "Licenser",
    adminZoneButton: "Admin zon",
    userZoneButton: "Användarzonen",
  },
  no: {
    usernamePlaceholder: "Brukernavn",
    logoutButton: "Logg ut",
    usernameCopied: "Brukernavn kopiert",
    packages: "Pakker",
    categories: "Kategorier",
    licenses: "Lisenser",
    adminZoneButton: "Admin område",
    userZoneButton: "Brukerområde",
  },
  ru: {
    usernamePlaceholder: "Имя пользователя",
    logoutButton: "Выйти",
    usernameCopied: "Имя пользователя скопировано",
    packages: "Пакеты",
    categories: "Категории",
    licenses: "Лицензии",
    adminZoneButton: "Администраторская зона",
    userZoneButton: "Пользовательская зона",
  },
  da: {
    usernamePlaceholder: "Brugernavn",
    logoutButton: "Log ud",
    usernameCopied: "Brugernavn kopieret",
    packages: "Pakker",
    categories: "Kategorier",
    licenses: "Licenser",
    adminZoneButton: "Admin zone",
    userZoneButton: "Brugerzone",
  },
  fi: {
    usernamePlaceholder: "Käyttäjänimi",
    logoutButton: "Kirjaudu ulos",
    usernameCopied: "Käyttäjänimi kopioitu",
    packages: "Paketit",
    categories: "Kategoriat",
    licenses: "Lisenssit",
    adminZoneButton: "Admin-alue",
    userZoneButton: "Käyttäjäalue",
  },
  ar: {
    usernamePlaceholder: "اسم المستخدم",
    logoutButton: "تسجيل الخروج",
    usernameCopied: "تم نسخ اسم المستخدم",
    packages: "الحزم",
    categories: "الفئات",
    licenses: "التراخيص",
    adminZoneButton: "منطقة المسؤول",
    userZoneButton: "منطقة المستخدم",
  },
};
